<script lang="ts" context="module">
  import { createEventDispatcher } from "svelte";
</script>

<script lang="ts">
  export let name: string = "";
  export let id: string;
  export let checked: boolean = false;
  export let disabled: boolean = false;
  export let value: any = undefined;
  export let size: string = "medium";
  /**
  When embedded inside a label, the checkbox is invoked whenever a click is detected anywhere inside the label. In that case, we shouldn't invoke the change ourselves.
  */
  export let embeddedInLabel = false;

  const dispatch = createEventDispatcher();

  if (size === "medium") {
    size = "18px";
  } else if (size === "small") {
    size = "13px";
  }

  function onChange() {
    // if (!embeddedInLabel) {
    //   checked = !checked;
    // }
    dispatch("change", { checked, id });
  }
</script>

<label for={id} class="relative flex items-center checkbox-container" style="--size: {size}">
  <input class="mr-4" type="checkbox" {name} {id} bind:checked on:keydown {value} {disabled} on:change={onChange} />
  <div class="pointer-events-none checkbox-layout checkbox-container"><span class="check-icon">✓</span></div>
</label>

<style>
  .checkbox-container {
    width: var(--size, 18px);
    min-width: var(--size, 18px);
    height: var(--size, 18px);
  }

  input {
    width: 100%;
    height: 100%;
    opacity: 0;
    outline: 0;
  }

  .checkbox-layout {
    color: white;
    position: absolute;
    left: 0;
    top: 0;
    transition: all 0.3s ease;
    border-radius: 3px;
    border: 2px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    background-color: #fff;
    cursor: default;
  }

  .check-icon {
    display: none;
  }

  input:focus + .checkbox-layout {
    outline: none;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
    border-color: #63b3ed;
  }
  input:checked + .checkbox-layout {
    background: #00a4bc;
    border-color: #00a4bc;
    font-size: 12px;
  }
  input:checked + .checkbox-layout .check-icon {
    display: block;
  }

  input:disabled + .checkbox-layout {
    pointer-events: none;
    background-color: #bbbbbb50;
    border-color: #bbbbbb;
  }
  input:disabled:checked + .checkbox-layout {
    background-color: #bbbbbb;
  }
</style>
